// Colores del modo oscuro usados en estilos inline (JS).
// Mantener sincronizados con las variables de body[data-theme="dark"] en utils/globalStyles.css.
export const darkPalette = {
  bgDefault: "#121212",
  cardBg: "#242424",
  altRowBg: "#2a2a2a",
  hoverBg: "#2c2c2c",
  border: "#333",
  textPrimary: "#e0e0e0",
  textSecondary: "#a0a0a0",
  accent: "#90caf9",
  accentBorder: "#5090c0",
  selectedBg: "#1a3a5c",
};

// Fondo de los switches de filtro (FilterSwitches) según estado y tema.
export const getSwitchBg = (color, checked, isDark) => {
  if (isDark) return checked ? `${color[900]}88` : `${color[900]}44`;
  return checked ? color[100] : color[50];
};

export const getSwitchColor = (color, isDark) =>
  isDark ? color[300] : color[500];
